import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';

import './about.scss';
import ImageGallery from '../app/components/ImageGallery.NoTween';

class About {
  constructor() {
    this.layout();
    // initButtons();
    this.initGallery();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('about-template'), {}));

    Localizr.parseObjectList(settings.sections.about.items);
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}

  initGallery() {
    new ImageGallery({
      shell: document.querySelector('.about-gallery-images'),
      lastBtn: document.querySelector('.about-back'),
      nextBtn: document.querySelector('.about-next'),
      images: settings.sections.about.gallery,
      slideEnabled: false,
    });
  }
}

export default About;
